export default __webpack_public_path__ + "static/media/cny.cd2a983d.png";